import { render, staticRenderFns } from "./AppContact.vue?vue&type=template&id=046c493b&scoped=true&"
import script from "./AppContact.vue?vue&type=script&lang=js&"
export * from "./AppContact.vue?vue&type=script&lang=js&"
import style0 from "./AppContact.vue?vue&type=style&index=0&id=046c493b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046c493b",
  null
  
)

component.options.__file = "AppContact.vue"
export default component.exports